<template>
  <div>
    <form
      @submit.prevent="do_submit"
      ref="contact_form"
      :class="form_class"
      v-if="contact_form_status == 0"
    >
      <!--      <h1 class="text-main-color uppercase font-bold mb-8 text-center">-->
      <!--        Contact Us-->
      <!--      </h1>-->
      <div class="block text-gray-700 text-sm text-center pb-3">
        Please submit a question or request contact from an
        <strong>Allergan representative</strong>.
      </div>

      <div class="md:grid md:grid-cols-2 md:gap-3 mt-3">
        <template v-for="item in form_model">
          <SimpleTextField
            :id="item.id"
            :label="item.label"
            v-model="item.value"
            :extra_field_class="item.extra_class"
            :type="item.type"
            v-if="item.type == 'text'"
            :key="item.id"
            :required="item.required"
          />
          <SimpleTextArea
            :id="item.id"
            :label="item.label"
            v-model="item.value"
            :extra_field_class="item.extra_class"
            :type="item.type"
            v-if="item.type == 'textarea'"
            :key="item.id"
            :required="item.required"
          />
          <SimpleSelectBox
            :id="item.id"
            :label="item.label"
            v-model="item.value"
            :extra_field_class="item.extra_class"
            :type="item.type"
            :options="item.options"
            v-if="item.type == 'selectbox'"
            :key="item.id"
            :required="item.required"
          />
          <HiddenField
            :id="item.id"
            v-model="item.value"
            v-if="item.type == 'hidden'"
            :key="item.id"
          />
        </template>
      </div>

      <div class="mt-3">
        <template v-for="item in form_model">
          <div :key="item.id" v-if="item.type == 'checkboxgroup'">
            <div class="mt-4">
              <label class="block text-gray-700 text-sm font-bold mb-0 sm:mb-2"
                ><span :class="item.extra_class"
                  >{{ item.label }} *</span
                ></label
              >
            </div>
            <div class="grid grid-cols-1">
              <label
                v-for="checkbox_option in item.options"
                class="block text-sm mb-1"
              >
                <input
                  v-model="item.value"
                  :name="item.id + '[]'"
                  type="checkbox"
                  :value="checkbox_option[0]"
                />&nbsp;&nbsp;{{ checkbox_option[1] }}
              </label>
            </div>
          </div>
        </template>
      </div>

      <div class="text-xs pb-3 text-justify">
        By submitting this request, you are opting in to receive emails from
        Allergan Eye Care. This will allow for us to digitally communicate with
        you. You may withdraw your consent at any time by clicking the
        "unsubscribe" link in our emails.
      </div>

      <div class="flex items-center justify-center mt-4">
        <button
          class="bg-gray-900 hover:bg-gray-800 text-white font-bold py-2 px-12 rounded focus:outline-none focus:shadow-outline"
          type="submit"
        >
          Submit
        </button>
      </div>
    </form>
    <div
      class="max-h-screen py-24 text-center border-white border-2"
      v-if="contact_form_status == 1"
    >
      <img src="../../assets/loading.svg" class="mx-auto" />
    </div>
    <div
      class="success py-40 text-center text-gray-900"
      v-if="contact_form_status == 2"
    >
      <strong>Submission complete</strong><br /><br />
      An Allergan representative will contact you
    </div>
    <div class="error py-40 text-center" v-if="contact_form_status == 3">
      <strong class="text-red-500">Sorry, there was an error!</strong
      ><br /><br />
      The form could not be submitted. Please try again.
    </div>
  </div>
</template>
<script>
import SimpleTextField from "../form/SimpleTextField";
import SimpleTextArea from "../form/SimpleTextArea";
import SimpleSelectBox from "../form/SimpleSelectBox";
import HiddenField from "../form/HiddenField";
import { mapState, mapGetters } from "vuex";

export default {
  name: "ContactForm",
  components: {
    SimpleTextField,
    HiddenField,
    SimpleTextArea,
    SimpleSelectBox
  },
  data() {
    return {
      form_class: "contact_form_page text-black",
      timer: null,

      form_model: [
        {
          id: "name",
          type: "text",
          required: true,
          label: "First Name",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },
        {
          id: "last_name",
          type: "text",
          required: true,
          label: "Last Name",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },
        {
          id: "degree",
          type: "text",
          required: false,
          label: "Degree",
          value: "",
          extra_class: "",
          validation: []
        },
        {
          id: "email",
          type: "text",
          required: true,
          label: "Email",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },

        {
          id: "phone",
          type: "text",
          required: false,
          label: "Phone",
          value: "",
          extra_class: "",
          validation: []
        },

        {
          id: "comments",
          type: "textarea",
          required: true,
          label: "Questions/Comments",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },

        {
          id: "event_tag",
          type: "hidden",
          required: false,
          label: "Event Tag",
          value: "",
          extra_class: "",
          validation: []
        }
      ]
    };
  },
  computed: {
    ...mapState(["site_config", "contact_form_status"]),
    ...mapGetters(["eventTag"])
  },

  methods: {
    do_submit(app_mode) {
      let formData = new FormData();

      let valid_form = true;

      this.form_model.forEach((item) => {
        let valid_field = true;
        let validation = item.validation;
        let error_class = "border-red-500";
        validation.forEach((validation_type) => {
          switch (validation_type) {
            case "notempty":
              if (item.value.length <= 0) {
                valid_form = false;
                valid_field = false;
                error_class = "border-red-500";
              }

              break;
            case "notempty_array":
              if (item.value.length <= 0) {
                valid_form = false;
                valid_field = false;
                error_class = "text-red-500";
              }
              break;
          }
        });
        if (valid_field) {
          item.extra_class = "";
        } else {
          item.extra_class = error_class;
        }
      });

      //for debugging purposes, allow the form to always be valid
      //so we don't need to fill it in all the time
      if (!this.site_config.validate_form) {
        valid_form = true;
      }

      if (!valid_form) {
        return;
      }

      var data_to_submit = new FormData();

      this.form_model.forEach((item) => {
        data_to_submit.append(item.id, item.value);
      });

      this.$store.dispatch("submit_contact_form", data_to_submit);

      this.$refs.contact_form.reset();

      this.$ga.event(this.eventTag + "contact_form", "submit", "submit", 1);
    },
    reset_form() {
      this.$store.dispatch("set_contact_form_status", 0);
    }
  },
  mounted() {
    this.form_model.forEach((item) => {
      if (item.id == "event_tag") {
        item.value = this.eventTag;
      }
    });
  },
  watch: {
    contact_form_status(val) {
      switch (val) {
        case 2:
        case 3:
          this.timer = setTimeout(this.reset_form.bind(this), 6000);
          break;
      }
    }
  }
};
</script>
<style scoped>
.hidden-fields {
  height: 0;
  opacity: 0;
  transition: all 0.1s;
  overflow: hidden;
}
.hidden-fields.active {
  opacity: 1;
  height: auto;
}
.form-option-list {
  margin-top: 9px;
}
.form-option-list li {
  margin-bottom: 6px;
}
.form-option-list a {
  color: #2b6cb0;
}
</style>
<style>
@media only screen and (min-width: 640px) {
  .contact_form_page .simple-field-container {
    margin-bottom: 3px;
  }

  .contact_form_page .simple-field-container label {
    margin-bottom: 1.7px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/ContactFormPage.vue